<template>
  <div class="view">
    <van-popup v-model="isWx"
      class="overlay-bg"
      position="bottom"
      :style="{ height: '100%' }">
      <van-image
          :src="downBg"
          fit="contain"
        />
    </van-popup>
    <div v-if="device!='iPhone'">
      <div class="c-content tb-20"> 
        <div class="tb-20">
          <van-image
            radius = "15"
            width = "100"
            :src="icon"
          />
        </div>
          <van-tabs v-model="androidModel" type="card" color="#ff7700" background="">
            <van-tab title="通用手机" name="normal">
              <div class="c-content"> 
                <van-image
                  class="tb-20"
                  width = "150"
                  @click="down"
                  src="https://i.yyii.info/static/ciguang_v1/image/down_android.png"
                />
                <div class="c-text">  
                  「慈光讲堂&行一共修」3.0版<br/>軟件截圖
                </div>     
                <div class="van-hairline--top"></div>
                  <van-image
                  class="c-image"
                    v-for="(item, index) in list" 
                    :key="index"
                    :src="item"
                    fit="contain"
                  />
              </div>
              <div class="c-content padding-10"> 
                <van-image
                    width = "150"
                    @click="down"
                    src="https://i.yyii.info/static/ciguang_v1/image/down_android.png"
                  />
              </div> 
            </van-tab>
            <van-tab title="OPPO手机" name="oppo">
              <div class="c-content"> 
                <van-image
                  class="tb-20"
                  width = "150"
                  @click="downOppo"
                  src="https://i.yyii.info/static/ciguang_v1/image/down_oppo.png"
                />
                <div class="c-text">  
                  「慈光讲堂&行一共修」3.0版<br/>軟件截圖
                </div>     
                <div class="van-hairline--top"></div>
                  <van-image
                  class="c-image"
                    v-for="(item, index) in list" 
                    :key="index"
                    :src="item"
                    fit="contain"
                  />
              </div>
            </van-tab>
          </van-tabs>
      </div>
    </div>
    <div v-if="device=='iPhone'">
      <div class="c-content"> 
        <div class="c-content tb-20"> </div>
        <div class="icon-title">大陆地区以外用户</div>
          <van-image
            width = "150"
            @click="down"
            src="https://i.yyii.info/static/ciguang_v1/image/down_iphone.png"
          />
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">重要提示</van-divider>
        <div class="icon-title-red">大陆地区用户</div>
        <div class="c-content-view">  
          「慈光讲堂」暂时在大陆地区无法安装，如果您曾经安装过「慈光讲堂」，请依照以下截图安装。
        </div>     
        <div class="c-content-view">  
          客服微信号：zhihuiciguang<br/>
          电子邮箱：zhihuiciguang@126.com
        </div>    
        <div class="van-hairline--top"></div>
        <van-image
          class="c-image"
          v-for="(item, index) in listiPhone" 
          :key="index"
          :src="item"
          fit="contain"
        />
         <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">其他选择</van-divider>
         <div class="icon-title-red">「净公道影」App</div>
        <div class="c-content-view" @click="goToDy">您也可以选择下载「净公道影」App</div>  
      </div>
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      title: '慈光讲堂APP下载',
      info: [],
      list: [
        'https://i.yyii.info/storage/preview/1200/picture/2024/10/8e83c3e992cb06b67f0ac6d129651531.png',
        'https://i.yyii.info/storage/preview/1200/picture/2024/10/4ddea88271b0f4d0ea2b91c57298e532.png',
        'https://i.yyii.info/storage/preview/1200/picture/2024/10/b68b622f329a2906cda2c66555110b97.png',
      ],
      listiPhone: [
        'https://i.yyii.info/static/ciguang_v1/image/ciguang-ios-help-00.jpg',
        'https://i.yyii.info/static/ciguang_v1/image/ciguang-ios-help-01.jpg',
        'https://i.yyii.info/static/ciguang_v1/image/ciguang-ios-help-02.jpg',
      ],
      icon:'https://i.yyii.info/static/ciguang_v1/image/appLogo.png',
      isWx: false,
      loading: true,
      device: 'Android',
      androidModel:'normal',
      downBg: "https://i.yyii.info/static/moblie_v1/image/apk-down-bg.png",
      imgHeight: document.documentElement.clientHeight,
      //download:"https://u.jingzong.org/u/cgapp",
      androidUrl: "https://i.yyii.info/uploads/apk/ciguang_v83_20241016_v1.apk",
      oppoUrl: "https://i.yyii.info/uploads/apk/ciguang_v83_oppo_v20241016_v1.apk",
      //download:"https://i.yyii.info/uploads/temp/ciguang_v3_v20240219_v1.apk",
      iosUrl : "https://itunes.apple.com/cn/app/%E6%85%88%E5%85%89/id1671070627?mt=8",
      dyUrl : "https://h5.jingzong.net/dy/192",
    }
  },
  methods: {
    //返回
    onBack(){
      this.$router.push({ path: `/i` })  
    },
    onLoad(){
      console.log('---');
    },
    down(){
      if(this.device=='iPhone'){
        window.location.href = this.iosUrl;
      }else{
        window.location.href = this.androidUrl;
      }
    },
    downOppo(){
      window.location.href = this.oppoUrl;
    },
    goTo(){  
       this.device = this.$tools.getDevice()
        // if (this.$tools.getDevice() == 'iPhone') {
        //     window.location.href = this.iosUrl;
        // }
    },
    goToDy(){
      window.location.href = this.dyUrl;
    }
  },
  beforeDestroy() {},
  mounted(){},
  created() {
    if(this.$tools.IsWeixinOrAlipay()==13){
      this.isWx = true;
    }else{
      this.goTo();
    }
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
};
</script>
<style  scoped>
.view{
    background-color: #f7f8fa;
    margin-bottom: 70px;  
}
.c-content{
  padding:5px 5px;
  text-align: center;
}
.c-image{
    padding:15px 15px;
    margin: 10px 20px;;
    background-color: #fff;
}
.tb-20{
  padding:30px 0;
}
.padding-10{
  padding:10px 10px;
}
.overlay-bg{
  background-color: #2e2e2e;
}
.c-text{
  padding:10px 20px;
  font-size: 22px;
  text-align: center;
}
.c-content-view{
  padding:10px 30px;
  font-size: 20px;
  text-align: left;
}
.icon {
    border-radius: 25px;
}
.icon-title{
  font-size: 22px;
  padding:5px 0 20px 0;
}
.icon-title-red{
  font-size: 22px;
  padding:5px 0 20px 0;
  color: #c00000;
}
.divider{
    color: #c00000;
}
</style>